__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "fgli-infinity-container-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(641), __webpack_require__.e(657)]).then(() => (() => (__webpack_require__(3657))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(501), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(7516))))));
			register("@mui/material", "5.15.1", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(311), __webpack_require__.e(999), __webpack_require__.e(940), __webpack_require__.e(641), __webpack_require__.e(163), __webpack_require__.e(501), __webpack_require__.e(986)]).then(() => (() => (__webpack_require__(4999))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(705), __webpack_require__.e(156)]).then(() => (() => (__webpack_require__(8705))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(182).then(() => (() => (__webpack_require__(3182))))));
			register("react-device-detect", "2.2.3", () => (Promise.all([__webpack_require__.e(56), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(7056))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(17), __webpack_require__.e(641), __webpack_require__.e(163), __webpack_require__.e(607)]).then(() => (() => (__webpack_require__(7017))))));
			register("react-router-dom", "6.13.0", () => (Promise.all([__webpack_require__.e(527), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(8527))))));
			register("react", "18.3.1", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
			register("zustand", "4.5.7", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(528)]).then(() => (() => (__webpack_require__(6528))))));
			initExternal(2367);
			initExternal(9015);
			initExternal(3431);
			initExternal(2477);
			initExternal(817);
			initExternal(4579);
			initExternal(8107);
			initExternal(141);
			initExternal(1199);
			initExternal(4599);
			initExternal(748);
			initExternal(8573);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};